import { StateToken } from '@ngxs/store';
import { IDocumentsStudyFolderState } from './document-card.state';

export const DOCUMENT_CARD_STATE_TOKEN = new StateToken<IDocumentsStudyFolderState>('documentCard');